import { zod } from '@acme/core'
import { z } from 'zod'

import ApiService from '../api.service'

export type Abono = z.infer<typeof zod.AbonoSchema>

export const createAbonoSchema = z
    .object({
        tipo: z.enum(['NORMAL', 'SAUDE_OCUPACIONAL']),
        fileUrl: z.any().optional(),
        data: z.date().or(z.string().refine(Boolean)),
        justificativa: z.string().trim().max(190).optional().default(''),
        descricao: z.string().trim().max(30).nullish().default(null),
        quantidadeHoras: z.coerce
            .string()
            .min(1, 'Obrigatório')
            .regex(new RegExp('^[0-9]{1,2}:[0-5][0-9]$')),
    })
    .refine(data => data.descricao || data.justificativa, {
        message: 'Informe uma descrição ou justificativa',
        path: ['justificativa'],
    })

const service = new ApiService<Abono>('abonos')

export const abonos = Object.assign(service, {
    aprovacao: new ApiService<Abono>('abonos/aprovacao'),
    reprovacao: new ApiService<Abono>('abonos/reprovacao'),
})
